import axiosInstance from '@/utils/api.js'

var state = {
  expiringPayments: []
}

var getters = {

  EXPIRING_PAYMENTS: (state) => {
    return state.expiringPayments
  }
}

var mutations = {
  SET_EXPIRING_PAYMENTS: (state, payload) => {
    state.expiringPayments = payload
  }
}

var actions = {
  GET_EXPIRING_PAYMENTS: async (context, payload) => {
    let result = await axiosInstance.get('/reports/burning_payments?start=' + payload.numDateStart +
    '&end=' + payload.numDateEnd +
    '&user_id=' + payload.userId +
    '&group_id=' + payload.group_id +
    '&accs_group_id=' + payload.accs_group_id +
    '&accounting_period_id=0&account_id=0' +
    '&limit=' + payload.limit +
    '&download=' + payload.download, {timeout: 45000})
    if (result.status === 200) {
      context.commit('SET_EXPIRING_PAYMENTS', result.data)
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/stores/reports/expiringPayments.js